module.exports = function () {
    if ( document.querySelector(".toggle-section") ) {
        const toggleSections = document.querySelectorAll(".toggle-section");

        toggleSections.forEach(section => {
            const buttons = section.querySelectorAll("[data-tab-button]"),
                contents = section.querySelectorAll("[data-tab-content]");
            
            if ( buttons && contents ) {
                let currentTab = 0,
                isInit = false;

                const initSection = () => {
                    if ( !isInit ) {
                        contents.forEach(content => {
                            content.style.visibility = null;
                        })
                        
                        isInit = true;
                    }
                }

                const setTab = (id) => {
                    initSection();
                    
                    buttons[currentTab].classList.add("btn--green-border");
                    buttons[currentTab].classList.remove("btn--green");
                    contents[currentTab].classList.add("invisible", "opacity-0");

                    buttons[id].classList.add("btn--green");
                    buttons[id].classList.remove("btn--green-border");
                    contents[id].classList.remove("invisible", "opacity-0");

                    currentTab = id;
                }

                buttons.forEach(button => {
                    button.addEventListener("click", () => {
                        setTab(button.dataset.tabButton);
                    })
                })
            }
        })
    }
}